<template>
  <div
    class="rounded-xl border-b-2 border-l-2 border-r-2 border-gray-200 overflow-hidden bg-white animate-pulse"
  >
    <div class="flex bg-gray-200 border-b-2 border-white">
      <div
        v-for="n in 6"
        :key="`group-${n}`"
        class="h-12 flex-1 border-r-2 border-white last:border-0 m-1 bg-slate-200 rounded opacity-50"
      ></div>
    </div>

    <div class="flex bg-gray-100 border-b border-gray-200 py-2">
      <div
        v-for="n in 12"
        :key="`col-head-${n}`"
        class="h-6 flex-1 mx-2 bg-slate-200 rounded"
      ></div>
    </div>

    <div class="flex flex-col">
      <div
        v-for="row in 10"
        :key="`row-${row}`"
        class="flex border-b border-gray-100 py-3 items-center hover:bg-gray-50"
      >
        <div
          v-for="col in 12"
          :key="`cell-${row}-${col}`"
          class="flex-1 h-4 mx-2 bg-slate-200 rounded"
        ></div>
      </div>
    </div>

    <div class="flex justify-center items-center py-4 border-t border-gray-100">
      <div class="h-8 w-64 bg-slate-200 rounded-full"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
